import Vue from 'vue'
import 'normalize.css/normalize.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import getPageTitle from '@/utils/get-page-title'
import  '../static/lib/ueditor/ueditor.config'
import  '../static/lib/ueditor/ueditor.all.min'
import  '../static/lib/ueditor/lang/zh-cn/zh-cn'
import '@/utils/directive.js'
import * as RongIMLib from '@rongcloud/imlib-next'

Vue.prototype.RongIMLib = RongIMLib

// import  '../static/lib/ueditor/ueditor.parse.min.js'
import hljs from 'highlight.js'
import 'highlight.js/styles/railscasts.css' 
Vue.directive('hljs', el => {
  let blocks = el.querySelectorAll('pre')
  Array.prototype.forEach.call(blocks, hljs.highlightBlock)
})
if(window.location.href.indexOf('xlp.leylh') >-1 || window.location.href.indexOf('xlptest.leylh') >-1){
  var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
  link.type='image/x-icon'
  link.href ='../tavicon.ico'
  document.getElementsByTagName('head')[0].appendChild(link)

}
import moment from 'moment'
import * as filters from './utils/filter.js';
import './assets/css/form.css'
import '@/styles/index.scss'
import '../theme/index.css'
import './assets/css/theme/f5222d/index.css'
import './assets/css/theme/fa541c/index.css'
import './assets/css/theme/faad14/index.css'
import './assets/css/theme/00ceb9/index.css'
import './assets/css/theme/52c41a/index.css'
import './assets/css/theme/1890ff/index.css'
import './assets/css/theme/722ed1/index.css'
import './assets/css/theme/2f54eb/index.css'
import './assets/css/theme/1e202d/index.css'

import '@/icons'
import axios from "axios";
import router from './router'//后引入router,以防正式环境加载覆盖了
import store from './store/index.js'
Vue.use(ElementUI);
Vue.prototype.$moment = moment;
Vue.prototype.$axios = axios;
moment.locale('zh-cn');
// const
if(window.location.href.indexOf('xlp.leylh') >-1 || window.location.href.indexOf('xlptest.leylh') >-1){
  Vue.prototype.$xlpSource = true;
}

router.beforeEach((to, from, next) => {
  // localStorage.setItem('tolink',to.path)
  // localStorage.setItem('fromlink',from.path)
  document.title = window.location.href.indexOf('xlp.leylh') >-1 || window.location.href.indexOf('xlptest.leylh') >-1 ?'薪乐聘' : getPageTitle(to.meta.title);

  if((from.name == 'positionManagement' && to.name== 'signupadmin' && to.fullPath.indexOf('?taskId') > -1) || (from.name == 'positionManagement' && to.name== 'recommendadmin'&& to.fullPath.indexOf('?taskId') > -1)|| (from.name == 'positionManagement' && to.name== 'selectionadmin'&& to.fullPath.indexOf('?taskId') > -1)){
    
    to.meta.keepAlive = false
    next()
  }else if((from.name == 'positionManagements' && to.name== 'signupadmin' && to.fullPath.indexOf('?taskId') > -1) || (from.name == 'positionManagements' && to.name== 'recommendadmin'&& to.fullPath.indexOf('?taskId') > -1)|| (from.name == 'positionManagements' && to.name== 'selectionadmin'&& to.fullPath.indexOf('?taskId') > -1)){
    to.meta.keepAlive = false
    next()
  }else{
   
    next();
  }
  // start progress bar
  // NProgress.start()

  // set page title
 
});  

function getQueryVariable(variable)
{
       var query = window.location.search.substring(1);
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] == variable){return pair[1];}
       }
       return(false);
}

router.afterEach((to) => {
  // 添加到后置导航守卫是因为跳转index.html后Vue / Vue Router 实例化完成后路由才会被挂载,如果放在前置导航首位则路由跳转不成功
  if (to.path === "/index.html") {
    // 获取真实路由参数
    var routePath = getQueryVariable("route");
    if (routePath) {
      // URI解码(将%2F解码为/)
      routePath = decodeURIComponent(routePath);
      // 如果默认跳转到首页,则不做二次路由跳转
      if (routePath !== '/index.html') {
        router.replace(routePath);
      }
    }
  }
  if(to.path == '/' && !localStorage.getItem('userId') && !localStorage.getItem('menuList') && !Vue.prototype.$xlpSource){
    router.replace('/leyeLogin');
  }else if(to.path == '/' && !localStorage.getItem('userId') && !localStorage.getItem('menuList') && Vue.prototype.$xlpSource){
    router.replace('/xlpLogin');
    
  }
  // NProgress.done()
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
